import { getCartCost, GetCartCostParams } from "@/http/catalogApi";
import { getCartCostQueryKey } from "@/utils/queryKeys";
import { useQuery } from "@tanstack/react-query";

export const useGetCartCostQuery = (params: GetCartCostParams, enabled: boolean = true) => {
  // Create hash from cart items for query key
  const cartHash = JSON.stringify(params.cart);

  return useQuery({
    queryKey: getCartCostQueryKey(params.club_id, cartHash),
    queryFn: () => getCartCost(params),
    select: (response) => response.data.data,
    enabled: enabled && !!params.club_id && params.cart.length > 0,
  });
};
